<ng-container *transloco="let t">
    <h1 align="center" mat-dialog-title>{{t(action)}} {{t(component)}}</h1>
    <div mat-dialog-content>
        <p>
            {{t(content)}}
        </p>
    </div>
    <div mat-dialog-actions align="center">
        <button mat-flat-button class="altair" (click)="onConfirmClick()" cdkFocusInitial>
            {{t(confirmButtonText)}}
        </button>
        <button mat-flat-button color="warn" mat-dialog-close>
            {{t(cancelButtonText)}}
        </button>
    </div>
</ng-container>
